import { ChangeDetectionStrategy, Component } from '@angular/core';
import { trackByValue } from '@y42/angular/util';
import { StatusRow } from '@y42/git';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { GitDiffTreeItem } from '../git-diff-tree.model';

const statusRowToColor: (status?: StatusRow) => 'added' | 'modified' | 'deleted' | 'conflict' | undefined = (
  status,
) => {
  const [HEAD, WORKDIR, _STAGE] = status || [];
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (HEAD) {
    case 0:
      return 'added';
    case 1:
      return WORKDIR === 0 ? 'deleted' : 'modified';
  }
  if (!status) {
    return;
  }
  switch (status.join(',')) {
    case '2,3,4':
    case '0,3,4':
    case '2,0,4':
    case '2,3,0':
    case '2,0,0':
    case '0,3,0':
    case '0,0,4':
      return 'conflict';
  }

  return;
};

@Component({
  selector: 'y42-git-diff-tree-item-change-cell-renderer.flex.items-center.h-full.fs-07',
  templateUrl: './git-diff-tree-item-change-cell-renderer.component.html',
  styleUrls: ['./git-diff-tree-item-change-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitDiffTreeItemChangeCellRendererComponent implements AgRendererComponent {
  params!: ICellRendererParams;
  color?: 'added' | 'modified' | 'deleted' | 'conflict' = 'added';

  readonly groupedChanges: Record<string, number> = {
    added: 0,
    modified: 0,
    deleted: 0,
  };

  readonly trackByValue = trackByValue;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const data: GitDiffTreeItem = params.data;
    if (this.params.node.group) {
      this.params.node.allLeafChildren.forEach((node) => {
        const color = statusRowToColor(node.data.status);
        if (color) {
          this.groupedChanges[color]++;
        }
      });
    } else {
      this.color = statusRowToColor(data?.status);
    }
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }
}
